import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { StationAddEditComponent } from '../add-edit/station-add-edit.component';
import { StationModel } from '../../models/stationModel';
import { RestAPIService } from 'src/app/services/restapi.service';
import { environment } from 'src/environments/environment';
import { StationListModel } from '../../models/stationListModel';
import * as moment from 'moment';
import { ConfirmDialogComponent } from 'src/app/components/confirmation/confirm-dialog.component';
import { ToastService } from 'src/app/services/toaster.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
  selector: 'app-station-list',
  templateUrl: './station-list.component.html',
  styleUrls: ['./station-list.component.css']
})
export class StationListComponent {
  public pageSize = 10;
    public currentPage = 0;
    public totalSize = 0;
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    stationList: StationListModel[] = [];
    sortedStationList: StationListModel[] = [];
    stationModel: StationModel = new StationModel();
    dataSource = new MatTableDataSource<StationListModel>();
    isAdvanceSearchFilter: boolean = false;
    filterKey: string = '';
    currentSort!: Sort;
    selectedOption: string = '';
    displayedColumns = ['name','crsCode', 'status','updatedAt', 'action'];
    isWritePermission: boolean = true;
    constructor(public _restAPI: RestAPIService, public dialog: MatDialog, private toast: ToastService, private permissionService: PermissionService){
      this._restAPI.loading  = false;
      if(!this.permissionService.has('station.write')){
        this.isWritePermission = false;
        this.displayedColumns = this.displayedColumns.filter(col => col !== 'action');
      }
    }

    ngOnInit() {
        if (localStorage["applyStationFilterValue"] === 'true') {
            this.getStationList(localStorage["stationFilterValue"]);
        }
        else {
            this.getStationList('');
        }
        localStorage["applyStationFilterValue"] = '';
    }

    onDisplayFilter(e : any) {
        this.isAdvanceSearchFilter = !this.isAdvanceSearchFilter;
        if(e) {
            e.stopPropagation();
        }
    }

    applyFilter(filterValue: string) {
        if (this.dataSource?.paginator) {
            this.dataSource.paginator.pageIndex = 0;
        }
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        localStorage["stationFilterValue"] = filterValue;
        this.dataSource.filter = filterValue;
    }

    applyActiveFilter(){
        this.dataSource.data = this.stationList;
        if(this.selectedOption === '1'){
            this.dataSource.data = this.dataSource.data.filter(x=>x.isActive === true);
        }
        else if(this.selectedOption === '2'){
            this.dataSource.data = this.dataSource.data.filter(x=>x.isActive === false);
        }
    }

    clearFilter(){
        this.selectedOption = '';
        this.filterKey='';
        this.applyActiveFilter();
        this.applyFilter('');
    }

    openStationDialog(stationModel: StationModel): void {
        const dialogRef = this.dialog.open(StationAddEditComponent, {
            width:"1024px",
            data:{
                stationModel: stationModel
            } 
        });
    
        dialogRef.afterClosed().subscribe(result => {
            this.stationModel = new StationModel();
            if (result) {
                this.getStationList(localStorage["stationFilterValue"]);
            }
            localStorage["applyStationFilterValue"] = '';
        });
    }

    async getStationList(filterValue : any) {
        this._restAPI.loading  = true;
        this._restAPI.get<StationListModel[]>(environment.apiURL + 'api/station/list').subscribe({
            next: (data) => {
                this._restAPI.loading  = false;
                for(let stationObj of data){
                    if(!stationObj.updatedOn){
                        stationObj.updatedOn = stationObj.createdOn;
                    }
                }
                this.stationList = data;
                this.sortedStationList = this.stationList.slice();
                this.totalSize = this.sortedStationList.length;
                this.dataSource.data = data;
                this.dataSource.filter = filterValue;
                this.filterKey = filterValue;
                this.dataSource.sort = this.sort;
                this.dataSource.paginator = this.paginator;
            },
            error: (error) =>{console.error(error); this._restAPI.loading  = false;}
        });
    }

    sortStations(sort: Sort) {
        if (this.dataSource?.paginator) {
            this.dataSource.paginator.pageIndex = 0;
        }
        // this.dataSource.filter = "";
        this.filterKey = "";
        this.currentSort = sort;
        this.pageSize = 10;
        this.currentPage = 0;
        
        this.sortStationArray(this.dataSource.data.slice(), this.currentSort);
        this.dataSource.data = this.sortedStationList;
    }

    onToggleChange(event: MatSlideToggleChange, id: string){
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '500px',
            data: {
              message: `Are you sure you want to ${event.checked ? 'active' : 'inactive'} this station?`
            }
        });
      
        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                console.log('Toggle changed:', event.checked); // true or false

                let postData = {
                    stationId: id,
                    isActive: event.checked
                    };

                this._restAPI.loading  = true;  
                this._restAPI.put<string>(environment.apiURL + 'api/station/activeinactive', postData).subscribe({
                    next: (results) => {
                        this._restAPI.loading  = false;
                        dialogRef.close(true);
                        this.toast.show("Station has been updated succussfully");
                    },
                    error: (error) => {console.error(error);this._restAPI.loading  = false;}
                });
            }
            else{
                event.source.checked = !event.checked;
            }
        });
    }

    private sortStationArray(stations: StationListModel[], sort: Sort): void {
        if (sort === undefined || !sort.active || sort.direction === '') {
            this.sortedStationList = stations.slice();
            return;
        }
        this.sortedStationList = stations.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'name': return compare(a.name ?? '', b.name ?? '', isAsc);
                case 'crsCode': return compare(a.crsCode ?? '', b.crsCode ?? '', isAsc);
                case 'status': return compare(a.isActive ?? false, b.isActive ?? false, isAsc);
                case 'updatedAt': return compare(a.updatedOn ?? new Date(-8640000000000000), b.updatedOn ?? new Date(-8640000000000000), isAsc);
                default: return 0;
            }
        });

        const part = this.sortedStationList.slice();
        this.sortedStationList = [];
        for (const station of part) {
            this.sortedStationList.push(station);
        }
    }

    private getDate(date : Date | null){
        if(date){
            return moment.utc(date).local().format('YYYY-MM-DD hh:mm A');
        }
        else{
            return null;
        }
    }
    
}

function compare(a: number | string | boolean | Date, b: number | string | boolean | Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}